import React from 'react';
import styled, { css } from 'styled-components';
import Button, { LinkButton } from 'components/Button/Button';
import { minBp } from '../../lib/theme';

export const Outer = styled.div`
  position: relative;
  z-index: 3;

  @media ${minBp('tabletLarge')} {
    padding-bottom: 160px;
  }
`;

export const Container = styled.div`
  ${({ theme, hasFilters }) => `
    height: 214px;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;

    @media ${minBp('mobileEnd')} {
      height: 500px;
    }

    @media ${minBp('tabletLarge')} {
      ${
        hasFilters
          ? `
        padding-bottom: 40px;
      `
          : ``
      }
    }
  `}
`;

export const ContentWrap = styled.div`
  ${({ theme }) => `
    display: flex;
    flex-direction: column;
    padding: 0 30px;
    min-height: 200px;
    justify-content: center;
    height: 100%;
    width: 100%;
    position: relative;

    @media ${minBp('tabletLarge')} {
      padding: 0;
    }
  `}
`;

export const Title = styled.h2`
  display: flex;
  justify-content: center;
  font-weight: 500;
  text-transform: uppercase;
  width: 100%;
  text-align: center;
  margin-bottom: 18px;
  font-size: 32px;
  line-height: 32px;
  font-family: ${({ theme }) => theme.fonts.dinDemi};
  color: #fff;
  position: relative;

  @media ${minBp('tablet')} {
    font-size: 50px;
    line-height: 50px;
  }

  @media ${minBp('tabletLarge')} {
    font-size: 80px;
    line-height: 80px;

    &:not(:last-of-type) {
      margin-bottom: 40px;
    }
  }
`;

export const ButtonWrapper = styled.div`
  ${({ theme }) => `
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
    position: absolute;
    top: 65%;
    left: 50%;
    transform: translateX(-50%);
    width: 100%;

    @media ${minBp('tablet')} { 
      top: 60%;
      width: auto;
      min-width: 500px;
    }

    @media ${minBp('tabletLarge')} {
      flex-wrap: nowrap;
      top: inherit;
      left: inherit;
      transform: none;
      width: 100%;
      position: relative;
    }
  `}
`;

export const HeroButtonStyle = css`
  ${({ whiteBackground, theme }) => `
    display: flex;
    flex-basis: calc(50% - 8px);
    margin: 4px;
    height: 32px;
    padding: 2px 0 0;
    font-size: 12px;
    text-transform: uppercase;
    justify-content: center;
    cursor: pointer;
    white-space: nowrap;

    &:focus {
        color: ${theme.colors.buttons.default};
        background-color: ${theme.colors.buttons.white};
    }

    @media ${minBp('tabletLarge')} {
      height: 40px;
      margin: 0 20px;
      flex-basis: calc(50% - 20px);
      font-size: 17px;
      padding: 11px 20px 8px;
      max-width: 271px;
    }

    ${whiteBackground &&
      `color: ${theme.colors.buttons.default};
      background-color: ${theme.colors.buttons.white};

      &:focus {
        color: ${theme.colors.buttons.white};
        background-color: ${theme.colors.buttons.default};
      }`}
  `}
`;

const _Button = ({ whiteBackground, ...props }) => <Button {...props} />;

export const HeroButton = styled(_Button)`
  ${HeroButtonStyle};
`;

const _LinkButton = ({ whiteBackground, ...props }) => <LinkButton {...props} />;

export const HeroLinkButton = styled(_LinkButton)`
  ${HeroButtonStyle};
`;

export const HeroImageWrapper = styled.div`
  position: absolute;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  background-color: #585a5f;
`;

export const HeroImage = styled.div``;
